module.exports = __webpack_public_path__ + "assets/img/ic-interchange.bb072543.svg";